import { render, staticRenderFns } from "./BankPayments.vue?vue&type=template&id=e3bedfb6"
import script from "./BankPayments.vue?vue&type=script&lang=js"
export * from "./BankPayments.vue?vue&type=script&lang=js"
import style0 from "./BankPayments.vue?vue&type=style&index=0&id=e3bedfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports